export const menus = [
    {
        title: 'Atendimentos',
        index: 1,
        gap: true
    },
    {
        title: 'Chamados',
        index: 2
    },
    {
        title: 'Regulação',
        index: 3
    }
];
